export const lightTheme = {
    body: '#FBFCFD',
    cardBackground: '#FBFCFD',
    cardBackgroundActive: '#CCD9E5',
    overlay: 'rgba(0, 0, 0, 0.5);',
    text: '#000000',
    boxShadow: '0px 0px 16px rgba(23, 23, 23, 0.1)',
    gradientBlue: 'linear-gradient(180deg, #00D2FF 0%, #3A7BD5 100%)',
    gradientBlueRight: 'linear-gradient(270deg, #00D2FF 0%, #3A7BD5 100%)',
    gradientRed: 'linear-gradient(180deg, #FF512F 0%, #DD2476 100%)',
    gradientRedRight: 'linear-gradient(270deg, #FF512F 0%, #DD2476 100%)',
    transition: '0.3s ease',
}

export const darkTheme = {
    body: '#1D2025',
    cardBackground: '#243B53',
    cardBackgroundActive: '#334E68',
    overlay: 'rgba(255, 255, 255, 0.5);',
    text: '#F0F4F8',
    boxShadow: '0px 0px 16px rgba(98, 125, 152, 0.25)',
    gradientBlue: 'linear-gradient(180deg, #00D2FF 0%, #3A7BD5 100%)',
    gradientBlueRight: 'linear-gradient(270deg, #00D2FF 0%, #3A7BD5 100%)',
    gradientRed: 'linear-gradient(180deg, #FF512F 0%, #DD2476 100%)',
    gradientRedRight: 'linear-gradient(270deg, #FF512F 0%, #DD2476 100%)',
    transition: '0.3s ease',
}